import React, { useEffect, useRef, useState } from "react";
import { test } from "utils/helpers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "./ParticipantListMenuItem.scss";

const InRoomAnnouncementParticipantListMenuItem = ({ participant }) => {
  const { t } = useTranslation();
  const inRoomAnnouncementParticipants = useSelector(
    (state) => state.inRoomAnnoucement?.inRoomAnnouncementParticipants
  );
  const remoteParticipant = useRef(null);
  const [id, setID] = useState(null);
  const getScipId = (id) =>
    id?.substring?.(id.indexOf(":") + 1, id.indexOf(";"));

  const triggerCustomEvent = (eventName, data) => {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  };

  useEffect(() => {
    const tempParticipant = inRoomAnnouncementParticipants.find(
      (ccParticipant) =>
        ccParticipant.particpantId === getScipId(participant.id)
    );
    if (tempParticipant) {
      remoteParticipant.current = tempParticipant;
      setID(tempParticipant.id);
    }
    // eslint-disable-next-line
  }, [inRoomAnnouncementParticipants]);

  useEffect(() => {
    const tempParticipant = inRoomAnnouncementParticipants?.find(
      (ccParticipant) =>
        ccParticipant.particpantId === getScipId(participant.id)
    );
    if (tempParticipant) {
      remoteParticipant.current = tempParticipant;
      setID(tempParticipant.id);
    }
    // eslint-disable-next-line
  }, []);

  if (
    !remoteParticipant.current ||
    !remoteParticipant.current.isEnable ||
    id === null
  ) {
    return null;
  }
  return (
    <li
      className="participant-nav__list-item"
      onClick={() => {
        triggerCustomEvent("inRoomAnnouncementClicked", {
          detail: remoteParticipant.current,
        });
      }}
      {...test("INROOMANNOUNCEMENT")}
    >
      <span
        className={`participant-nav__icon participant-nav__icon--announcement ${id}`}
      ></span>
      <span className="participant-nav__title">{t("ANNOUNCEMENTS")}</span>
    </li>
  );
};

export default InRoomAnnouncementParticipantListMenuItem;
